// Toast state + push hook — Polish B2.

import { useCallback, useState } from "react";

import type { ToastMessage } from "./Toast";


export interface UseToastApi {
  toasts: ToastMessage[];
  push: (text: string, kind?: ToastMessage["kind"]) => void;
  dismiss: (id: string) => void;
}


export function useToast(): UseToastApi {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const push = useCallback(
    (text: string, kind: ToastMessage["kind"] = "success") => {
      setToasts((prev) => [
        ...prev,
        {
          id: `t_${Math.random().toString(36).slice(2, 10)}`,
          text,
          kind,
        },
      ]);
    },
    [],
  );

  const dismiss = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, push, dismiss };
}
